import React from 'react'
import { Goods } from '@/model/types/goods'
import { ColumnsType } from 'antd/es/table'
import $msg from '@/utils/message'
import { useRequest } from 'ahooks'
import { IPagination } from '@/model/types/common'
import { $post } from '@/api'
import { AutoResizer, WithScrollLoad } from '@/utils/utils-widget'
import { Table } from 'antd'
import { IUser } from '@/model/types/user'
import { showLayer } from '@/utils/layer'
import StockReturnDetail from '../stock-return-detail/stock-return-detail'

export interface ReturnGoodsList {
    goods: Goods
    refund_amount: number
    id: number
}

export interface StockReturnList {
    create_time: string
    id: number
    order_no: string
    creator: {
        id: number
        user: IUser
    }
    goods_list: ReturnGoodsList[]
}

interface StockReturnTabelProps {
    date: string[]
}

const StockReturnTabel: React.FC<StockReturnTabelProps> = props => {
    const columns: ColumnsType<StockReturnList> = [
        {
            title: '#',
            key: 'index',
            width: 50,
            render: (value, record, index) => index + 1,
        },
        {
            title: '退货时间',
            key: 'create_time',
            dataIndex: 'create_time',
        },
        {
            title: '退货商品',
            key: 'goods_list',
            dataIndex: 'goods_list',
            render: val => val[0].goods.name,
        },
        {
            title: '退货量',
            key: 'goods_list',
            dataIndex: 'goods_list',
            render: val => `${val[0].refund_amount}${val[0].goods.stock_unit.name}`,
        },
        {
            title: '操作',
            width: 70,
            align: 'center',
            render: (val, record) => (
                <span
                    className="action"
                    onClick={() => {
                        showLayer(<StockReturnDetail id={record.id} />)
                    }}
                >
                    详情
                </span>
            ),
        },
    ]

    const requestHandle = useRequest<
        {
            list: StockReturnList[]
            pagination: IPagination
        },
        {
            purchase_refund_list: StockReturnList[]
            pagination: IPagination
        }
    >(
        val => {
            return $post({
                url: '/warehouse/getpurchaserefundorder',
                params: {
                    limit: 20,
                    page: val?.pagination?.page ? val.pagination.page + 1 : 1,
                    from_date: props.date[0],
                    to_date: props.date[1],
                },
            })
        },
        {
            isNoMore: data => {
                if (data?.pagination) {
                    return data?.pagination.page === data?.pagination.page_count
                } else {
                    return false
                }
            },
            loadMore: true,
            formatResult: data => {
                return {
                    list: data.purchase_refund_list,
                    pagination: data.pagination,
                }
            },
            onError: e => {
                $msg('error', e.message)
            },
            refreshDeps: [props.date],
        },
    )

    return (
        <div className="table-container">
            <AutoResizer>
                {({ height }) => {
                    return (
                        <WithScrollLoad data-expaned data-overflow-hidden scrollloadhandle={requestHandle}>
                            <Table
                                rowKey={record => record.id}
                                loading={requestHandle.loading || requestHandle.loadingMore || void 0}
                                bordered
                                pagination={false}
                                columns={columns}
                                dataSource={requestHandle.data?.list}
                                scroll={{ x: 'max-content', y: height - 50 }}
                            />
                        </WithScrollLoad>
                    )
                }}
            </AutoResizer>
        </div>
    )
}

export default StockReturnTabel
